import React from 'react';
import PropTypes from 'prop-types';
import {
  contentElementProptype,
  contentItemProptype,
} from 'propTypes/contentProptypes';
import { MainAreaTitleSection } from 'components/layout/MainAreaTitleSection';
import { References } from 'components/content/References';
import './AvailableTreatmentsPage.scss';
import { PromoBanner } from 'components/layout/PromoBanner';
import { BannerImage } from 'components/content/BannerImage';
import ContentCard from 'modules/contentCard/ContentCard';
import { useWebsiteConfigObject } from 'websiteConfig/useWebsiteConfig';
import { getSelectionValue } from 'utils/contentUtils';
import { useGoogleAnalytics } from 'hooks/useGoogleAnalytics';
import AdverseEventsCompliance from 'components/content/AdverseEventsCompliance';
import { useSelector } from 'react-redux';
import { ApprovalCode } from 'components/content/ApprovalCode';
import { getUrlCountryPath } from 'utils/urlUtils'


const ContentRow = ({
  sectionTitle,
  logoCards,
  locale = null
}) => {
 
  const { tLearnMore } = useWebsiteConfigObject();
  const { trackEventWithContentType } = useGoogleAnalytics();
  const { redesign } = useSelector(state => state.ui);
   const isLocaleMismatch = () => {
        const localeStr = typeof locale === "string" ? locale : locale?.value;
        if (!localeStr) return false;
        const currentLocale = localeStr.toLowerCase();
        const urlLocale = getUrlCountryPath()?.toLowerCase?.() || '';
        return !currentLocale.includes(urlLocale);
    };

    if (isLocaleMismatch()) return null;

    const checkLocaleMatchLogoCard = (cardItem) => {
     
      
      if (!cardItem) {
        return false; // no logoCard at all
      }

      const locale = cardItem?.elements?.locale?.value
    
   

      // If locale is not set, treat as true
      if (!locale) {
        return true;
      }
      console.log(locale.toLowerCase().includes(getUrlCountryPath().toLowerCase()) ||
          getUrlCountryPath().toLowerCase().includes(locale.toLowerCase()))
      return(
      locale.toLowerCase().includes(getUrlCountryPath().toLowerCase()) ||
          getUrlCountryPath().toLowerCase().includes(locale.toLowerCase())
      )
              

    }




  if(redesign){
    return  (
      <div
        className="category-row"
      >
        {logoCards?.length > 0 && 
          <div className="category-row-left">
            <div className='categorie-title'>
            {
              sectionTitle && (
                <h3 className="category-name redesign">
                  {sectionTitle}
                </h3>
              )
            }
            </div>
            <div className='categorie-span'>
              <h3></h3>
            </div>
          
          </div>
        }
        <div className="category-row-right tets">
          {
            logoCards?.length > 0 && logoCards?.map((cardItem, index) => {
              let localeMatchLogoCard = checkLocaleMatchLogoCard(cardItem)
              
              const { elements } = cardItem || {}
    
              if (!elements) return null
              
              let cardType = getSelectionValue(elements?.cardType);
              if (cardType && localeMatchLogoCard) {
                return (
                  <div
                    key={`${cardItem.id || 'logo-card'}-${index}`}
                    onClick={() => trackEventWithContentType('product-tile', elements.title?.value)}
                    className="list-content-page-card-wrapper tessst"
                  >
                    <ContentCard
                      theme='primary'
                      category={cardType === "IconCard" ? elements?.category?.value : ""}
                      brandLogo={cardType === "ImageCard" ? elements?.logoImage : ""}
                      href={elements?.link?.linkURL}
                      content={elements?.text}
                      linkText={tLearnMore}
                      clickable
                      alternateBg
                      locale={locale}

                    />
                  </div>
                )
              }
              else {
                 return (localeMatchLogoCard && 
                  <div
                    key={`${cardItem.id || 'logo-card'}-${index}`}
                    onClick={() => trackEventWithContentType('product-tile', elements.title?.value)}
                    className="list-content-page-card-wrapper"
                  >
                    <ContentCard
                      theme='primary'
                      category={elements?.category?.value}
                      brandLogo={elements?.logoImage}
                      href={elements?.link?.linkURL}
                      content={elements?.text}
                      linkText={tLearnMore}
                      clickable
                      alternateBg
                      locale={locale}
                    />
                  </div>
                )
              }
    
            })
          }
        </div>
      </div>
    )
  }
  return  (
    <div
      className="category-row"
    >
      <div className="category-row-left">
        {
          sectionTitle && (
            <h3 className="category-name testing">
              {sectionTitle}
            </h3>
          )
        }
      </div>
      <div className="category-row-right">
        {
           logoCards?.length > 0 && logoCards?.map((cardItem, index) => {
             let localeMatchLogoCard = checkLocaleMatchLogoCard(cardItem)
            const { elements } = cardItem || {}
  
            if (!elements && !localeMatchLogoCard) return null

            return (
              <div
                key={`${cardItem.id || 'logo-card'}-${index}`}
                onClick={() => trackEventWithContentType('product-tile', elements.title?.value)}
                className="list-content-page-card-wrapper"
              >
                <ContentCard
                  theme='primary'
                  category={elements?.category?.value}
                  brandLogo={elements?.logoImage}
                  href={elements?.link?.linkURL}
                  content={elements?.text}
                  linkText={tLearnMore}
                  clickable
                  alternateBg
                  locale={locale}
                />
              </div>
            )
          })
        }
      </div>
    </div>
  )
};

ContentRow.propTypes = {
  sectionTitle: PropTypes.string,
  logoCards: PropTypes.arrayOf(contentElementProptype),
};



const AvailableTreatmentsPage = ({
  content,
}) => {

  const {
    title,
    headerText,
    subtitle,
    section1Title,
    section2Title,
    logoCards1,
    logoCards2,
    cards,
    callout,
    bannerImage,
    references,
    veevaApprovalCode
  } = content.elements;
 

  const adverseEventsComplianceText = content?.elements?.basePage?.value?.adverseEventsComplianceText;


  // to remove these line of code when content is ready
  const section1TitleValue = section1Title && section1Title.value;
  const logoCards1Value = logoCards1 && logoCards1.values;

  const section2TitleValue = section2Title && section2Title.value;
  const logoCards2Value = logoCards2 && logoCards2.values;


  return (
    <section role="main" className="available-page-template">
      <MainAreaTitleSection
        title={title && title.value}
        description={headerText}
        category={subtitle && subtitle.value}
      />
      <section className="content-section">
        <div className="container">
          {/* this section need to be remove when all of the market change their content to use the dynamic one above */}
          
              <ContentRow
                sectionTitle={section1TitleValue}
                logoCards={logoCards1Value}
                locale= {cards}
              />
              <ContentRow
                sectionTitle={section2TitleValue}
                logoCards={logoCards2Value}
                locale={cards}
              />
            
          {
            cards?.values?.map( (card, index) => <ContentRow
              key={index}
              sectionTitle={card.elements?.title?.value}
              logoCards={card.elements?.logoCards?.values}

              locale={card?.elements?.locale?.value}
            />)
          }
          <PromoBanner
            content={callout}
          />
          {bannerImage && <BannerImage image={bannerImage} />}
          {adverseEventsComplianceText?.value && <AdverseEventsCompliance data={adverseEventsComplianceText} />}
          {veevaApprovalCode && veevaApprovalCode?.value && <ApprovalCode code={veevaApprovalCode} />}   
          <References
            references={references}
          />
        </div>
      </section>
    </section>
  );
};


AvailableTreatmentsPage.propTypes = {
  content: contentItemProptype,
};


export { AvailableTreatmentsPage };
